import { flow, types, getEnv } from 'mobx-state-tree'

import { Beneficiary } from '.'

const Beneficiaries = types
  .model('BeneficiariesModel', {
    items: types.optional(types.map(Beneficiary), {}),
  })
  .actions((self) => {
    const {
      services: { statisticsService },
    } = getEnv(self)

    return {
      add(beneficiary) {
        if (!beneficiary) {
          return null
        }

        self.items.set(beneficiary.id, beneficiary)

        return self.items.get(beneficiary?.id)
      },

      get(id) {
        return self.items.get(id)
      },

      load: flow(function* (params) {
        const response = yield statisticsService.queryBeneficiaries(params)

        const beneficiaries = response.content.map((beneficiary) => {
          self.items.set(beneficiary.id, beneficiary)
          return self.items.get(beneficiary.id)
        })

        return {
          response,
          beneficiaries,
        }
      }),
    }
  })

export const BeneficiariesRoot = types.model('BeneficiariesRoot', {
  beneficiaries: types.optional(Beneficiaries, {}),
})
